import { openDB } from "idb";

const DB_NAME = "experiment-timeline-db";
const STORE_NAME = "projects";

export async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
      }
    },
  });
}
export async function addProject(project) {
  const db = await getDB();
  await db.add(STORE_NAME, project);
}

export async function getAllProjects() {
  const db = await getDB();
  return db.getAll(STORE_NAME);
}

export async function updateProject(id, updatedProject) {
  const db = await getDB();
  await db.put(STORE_NAME, { ...updatedProject, id });
}

export async function deleteProject(id) {
  const db = await getDB();
  await db.delete(STORE_NAME, id);
}
